module.exports = __webpack_public_path__ + "7f249c2e372a3d1c6061ce8e7c95b987.svg";